import React from 'react';

import { DesignBlockMenuItem } from '../Components/DesignBlockMenuItem';

export const TemplateStudioPopupForm: React.FC = () => {
  return <DesignBlockMenuItem blockType={'popup'} />;
};
